export const ZH: Record<string, string> = {
  "Home": "主页",
  "Resource Selected": "已选择资源",
  "Resources List": "资源列表",
  "List": "列表",
  "Resources": "资源",
  "Find Colleague": "查找同事",
  "Settings": "设置",
  "Floor Plan": "楼层平面图",
  "Locations": "位置",
  "Categories": "分类",
  "Search resource name...": "搜索资源名称...",
  "Calendar": "日历",
  "View Details": "查看详情",
  "Add to My Favorites": "添加到我的收藏",
  "Remove": "移除",
  "Resource calendar": "资源日历",
  "Today": "今天",
  "Previous month": "上个月",
  "Next month": "下个月",
  "Previous year": "去年",
  "Next year": "明年",
  "Close": "关闭",
  "Field is required.": "必填项。",
  "Invalid date format.": "日期格式无效。",
  "S": "周日",
  "M": "周一",
  "T": "周二",
  "W": "周三",
  "F": "周五",
  "January": "一月",
  "February": "二月",
  "March": "三月",
  "April": "四月",
  "May": "五月",
  "June": "六月",
  "July": "七月",
  "August": "八月",
  "September": "九月",
  "October": "十月",
  "November": "十一月",
  "December": "十二月",
  "Jan": "一月",
  "Feb": "二月",
  "Mar": "三月",
  "Apr": "四月",
  "Jun": "六月",
  "Jul": "七月",
  "Aug": "八月",
  "Sep": "九月",
  "Oct": "十月",
  "Nov": "十一月",
  "Dec": "十二月",
  "st": "日",
  "nd": "号",
  "rd": "号",
  "th": "号",
  "Sunday": "星期日",
  "Monday": "星期一",
  "Tuesday": "星期二",
  "Wednesday": "星期三",
  "Thursday": "星期四",
  "Friday": "星期五",
  "Saturday": "星期六",
  "Sun": "周日",
  "Mon": "周一",
  "Tue": "周二",
  "Wed": "周三",
  "Thu": "周四",
  "Fri": "周五",
  "Sat": "周六",
  "Su": "日",
  "Mo": "一",
  "Tu": "二",
  "We": "三",
  "Th": "四",
  "Fr": "五",
  "Sa": "六",
  "PM": "下午",
  "AM": "上午",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "您无法预订此资源，因为您的会议请求与资源的预订政策冲突。",
  "You need permissions to interact with this resource.":
    "您需要权限才能与此资源交互。",
  "Reason": "原因",
  "The resource cannot be booked {{day}} days in advanced.":
    "资源无法提前 {{day}} 天预订。",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "重复会议的结束日期不能超过今天{{day}} 天。",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "会议持续时间不能超过{{time}}分钟。",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "会议持续时间不能少于{{time}}分钟。",
  "Booking policy": "预订政策",
  "Available": "可用",
  "Selected": "已选择",
  "Booked": "已预订",
  "Closed": "关闭",
  "Filter Options": "筛选选项",
  "{{resource}} is deleted": "{{resource}}已删除。",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "此资源可预订，但任何与资源冲突的事件将不会被预订。",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "此资源可提前{{day}}天预订，超出此限制的事件将不会被预订。",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "此资源可预订，但会议持续时间必须至少{{time}}分钟。",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "此资源可预订，但会议持续时间不能超过{{time}}分钟。",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "预订此资源需要资源代表批准。您的请求将被转发，等待批准。",
  "Resource Name": "资源名称",
  "Description": "描述",
  "Resource Mail": "资源邮件",
  "Location": "位置",
  "Capacity": "容量",
  "Language": "语言",
  "Select an language": "选择一种语言",
  "Date/Time Format": "日期/时间格式",
  "First day of the week": "一周的第一天",
  "Please select a first day": "请选择一个第一天",
  "Please select a time format": "请选择一个时间格式",
  "Date Format": "日期格式",
  "Please select a date format": "请选择一个日期格式",
  "Date Separator": "日期分隔符",
  "Please select a date separator": "请选择一个日期分隔符",
  "Apply": "应用",
  "Default Location": "默认位置",
  "Clear": "清除",
  "Help": "帮助",
  "Unavailable": "不可用",
      "No data available": "没有可用数据",
      "More": "更多",
  "Available Floor Plans": "可用楼层平面图",
  "Default Categories": "默认分类",
  "List more Resources": "列出更多资源",
  "Attendees": "参与者",
  "Click on Further information to visit our support site": "点击详细信息访问我们的支持站点",
  "New Order": "新订单",
  "Save default categories successfully": "成功保存默认分类",
      "Save config date/time successfully": "成功保存配置日期/时间",
      "Save language successfully": "成功保存语言",
      "Save default location successfully": "成功保存默认位置",
      "And": "和",
  "Or": "或",
  "Available occurrences of the series": "系列的可用事件",
  "Conflicting Occurrences": "冲突事件",
  "Availability": "可用性",
  "Time Format": "时间格式",
  "You do not have permission to book this resource.": "您无权预订此资源。",
"This resource does not allow booking of recurring meetings.": "此资源不允许预订重复会议。",
"You cannot book this resource.": "您无法预订此资源。"
};
